(function () {
  'use strict';

  /* @ngdoc object
   * @name secure3d
   * @description
   *
   */
  angular
    .module('secure3d', [
      'ui.router'
    ]);
}());
